((StarFilter, $) => {
  'use strict';

  const activeClass = 'star-visible';
  let $container;
  let $search;
  let $names;
  let $loadMore;
  let $header;
  let $filtering;
  let $sidebar;
  let $sortMenu;
  let showingUpdateAmount = 4;
  let showing = showingUpdateAmount;
  let list = [];
  let allLoaded = false;

  const cacheDom = () => {
    $container = $('.js-star-search');
    $search = $container.find('.js-star-input');
    $names = $('.js-star-search-item');
    $loadMore = $('.js-star-load-more');
    $header = $('.js-sidebar-header');
    $filtering = $('.js-star-filtering');
    $sidebar = $('.js-star-sidebar');
    $sortMenu = $('.js-sort-bar-list');
  };

  const updateShowingAmount = (amount) => {
    if (!amount) {
      const nameSize = list.length || $names.length;
      if (nameSize - showing > showing) {
        showing += showingUpdateAmount;
        return false;
      }
      showing += nameSize % showingUpdateAmount;
      return true;
    }
    showing = amount;
  };

  const clearSearch = () => {
    $search.val('');
  };

  const hideLoad = (remove) => {
    $loadMore.parent().hide();
    if (remove) {
      $loadMore.parent().remove();
    }
  };

  const showLoad = () => {
    if (!allLoaded) {
      $loadMore.parent().show();
    }
  };

  const initMobile = () => {
    updateShowingAmount($names.length);
    $names.each(function () {
      const $this = $(this);
      if (!$this.hasClass(activeClass)) {
        $this.addClass(activeClass);
      }
    });
    hideLoad(true);
  };

  const bindUIActions = () => {
    $search.on('keyup', function search() {
      const $this = $(this);
      const query = new RegExp($this.val().trim().toLowerCase());
      list = [];
      let size = showing
      if (query) {
        $names.each(function checkForMatch() {
          const $this = $(this);
          const name = $this[0].dataset.starSearch;
          if (query.test(name)) {
            list.push($this);
          }
        });
      }
      size = list.length < size && list.length > 0 ? list.length : size;
      if (size < showing) {
        hideLoad();
      } else {
        showLoad();
      }
      $names.removeClass(activeClass);
      if (list.length > 0) {
        for (let i = 0; i < size; i++ ) {
          $(list[i]).addClass(activeClass);
        }
      } else {
        let stopAdding = false;
        $names.each(function addActive(index) {
          if (allLoaded) {
            $(this).addClass(activeClass);
          } else {
            if (!stopAdding) {
              $(this).addClass(activeClass);
              if (index === size - 1) {
                stopAdding = true;
              }
            }
          }
        });
      }
    });

    $loadMore.on('click', () => {
      allLoaded = true;
      hideLoad(true);
      updateShowingAmount($names.length);
      if (list.length) {
        for (var i = 0; i < list.length; i++) {
          $(list[i]).addClass(activeClass);
        }
      } else {
        $names.each(function (index) {
          if (index < showing) {
            $(this).addClass(activeClass);
          }
        });
      }
    });

    $header.on('click', function toggle() {
      const $this = $(this);

      if ($this.hasClass('active')) {
        $this.removeClass('active');
      } else {
        $this.addClass('active');
      }

      SortBar.rotate($this.find('.js-sidebar-caret'), 'sidebar-caret--rotate');
      if (list.length > 0 && list.length <= showing) {
        $this.siblings().not('.js-star-search-desktop').not($loadMore.parent()).slideToggle();
      } else {
        $this.siblings().not('.js-star-search-desktop').slideToggle();
      }
    });

    $filtering.on('click', () => {
      if ($(window).width() < 1200) {
        SortBar.scroll();
        $('.js-sort-menu .js-sorting-caret').removeClass('sorting-caret--rotate');
        SortBar.rotate($filtering.find('.js-sorting-caret'), 'sorting-caret--rotate');
      }
      $('.js-shop-title').toggleClass('active');
      $('.js-sorting-method').removeClass('active');
      $sortMenu.hide();
      $sidebar.slideToggle();
    });
  };

  const init = () => {
    cacheDom();
    bindUIActions();
    if ($(window).width() < 1200) {
      initMobile();
    }
    clearSearch();
    if (showing === $names.length) {
      hideLoad();
    }
  };

  StarFilter.init = init;
})(window.StarFilter = window.StarFilter || {}, jQuery);
